export interface IFiltersData {
  id: string;
  title: string;
  value: string;
}

// export const filtersData: Array<IFiltersData> = [
//   {id: '1', title: 'جدیدترین', value: 'lastest'},
//   {id: '2', title: 'پربازدیدترین', value: 'most_viewed'},
//   {id: '3', title: 'نزدیک ترین ', value: 'nearest'},
//   {id: '3', title: 'ارزان ترین', value: 'cheapest'},
//   {id: '3', title: 'گران ترین', value: 'most_expensive'},
// ];
// export const multiSelectData: Array<IFiltersData> = [
//   {id: '1', title: 'آگهی های فوری', value: 'has_immediate'},
//   {
//     id: '2',
//     title: 'پیشنهادات شگفت انگیز',
//     value: 'has_special_offer',
//   },
//   {id: '1', title: 'آگهی های فروشگاه ها', value: 'has_store'},
//   {
//     id: '2',
//     title: 'آگهی های دارای قیمت',
//     value: 'has_price',
//   },
// ];

export const filtersData = (inputGroupName: string) => {
  if (inputGroupName === 'lab') {
    return [
      {id: '1', title: 'جدیدترین', value: 'lastest'},
      {id: '2', title: 'پربازدیدترین', value: 'num_views'},
      {id: '3', title: 'نزدیک‌ترین ', value: 'nearest'},
    ];
  } else {
    return [
      {id: '1', title: 'جدیدترین', value: 'lastest'},
      {id: '2', title: 'پربازدیدترین', value: 'num_views'},
      {id: '3', title: 'نزدیک‌‌ترین ', value: 'distance'},
      {id: '3', title: 'ارزان‌ترین', value: 'ad_price'},
      {id: '3', title: 'گران‌ترین', value: '-ad_price'},
    ];
  }
};

export const multiSelectData = (inputGroupName: string) => {
  if (inputGroupName === 'lab') {
    return [
      {
        id: '1',
        title: 'پیشنهادات شگفت‌انگیز',
        value: 'has_special_offer',
      },
      {
        id: '2',
        title: 'آگهی‌های دارای قیمت',
        value: 'has_price',
      },
    ];
  } else {
    return [
      {id: '1', title: 'آگهی‌های فوری', value: 'has_immediate'},
      {
        id: '2',
        title: 'پیشنهادات شگفت‌انگیز',
        value: 'has_special_offer',
      },
      {id: '3', title: 'آگهی‌های فروشگاه ها', value: 'has_store'},
      {
        id: '4',
        title: 'آگهی‌های دارای قیمت',
        value: 'has_price',
      },
    ];
  }
};
